import { Mail } from "lucide-react";

export default function ShippingPolicyPage() {
    return (
        <div className="min-h-[70vh]" data-testid="shipping-policy-page">
            <div className="bg-card border-b border-border">
                <div className="container mx-auto px-6 lg:px-12 py-12 lg:py-20">
                    <p className="font-mono text-xs uppercase tracking-widest text-primary mb-4">Policy</p>
                    <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black text-foreground tracking-tight mb-4">
                        Shipping Policy
                    </h1>
                </div>
            </div>

            <div className="container mx-auto px-6 lg:px-12 py-12 lg:py-20 max-w-3xl">
                <div className="space-y-8 text-muted-foreground text-sm leading-relaxed">
                    <p>
                        All machinery shipments are dispatched via premium, fully insured nationwide commercial freight carriers to the 48 lower states. A flat-rate freight fee of <span className="text-foreground font-bold">$350.00</span> is applied to all heavy equipment orders at checkout.
                    </p>

                    <p>
                        Delivery of standard stock items occurs within <span className="text-foreground font-bold">10 business days</span>. Custom factory orders require <span className="text-foreground font-bold">14-21 business days</span> for logistics and configuration.
                    </p>

                    <p>
                        Tracking numbers will be issued via email upon carrier pickup.
                    </p>

                    <div>
                        <h2 className="font-heading text-lg font-bold text-foreground mb-3">Shipping Rates</h2>
                        <div className="bg-card border border-border">
                            <div className="flex justify-between p-4 border-b border-border">
                                <span>Heavy Machinery (Machines $8k+)</span>
                                <span className="text-foreground font-bold">$350.00 Flat Rate</span>
                            </div>
                            <div className="flex justify-between p-4">
                                <span>Accessories & Nozzles</span>
                                <span className="text-foreground font-bold">$15.00 Ground Shipping</span>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h2 className="font-heading text-lg font-bold text-foreground mb-3">Freight deliveries may require:</h2>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Forklift access</li>
                            <li>Commercial delivery address</li>
                            <li>Liftgate service (additional charges may apply)</li>
                        </ul>
                    </div>

                    <p>Shipping timelines shown on the website are estimates and may vary.</p>

                    <div className="border-t border-border pt-6">
                        <p className="text-foreground font-bold mb-2">Questions about shipping?</p>
                        <a href="mailto:info@dryicebulls.com" className="flex items-center gap-2 text-primary hover:text-primary/80 transition-colors">
                            <Mail className="h-4 w-4" /> info@dryicebulls.com
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
